<template>
  <div class="tables">
    <div class="container">
      <div class="row">
        <Navigation calculators />
        <Tables />
      </div>
      <QuizBanner />
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Tables from '../../components/Calculators/Content/Tables/index.vue';
import Navigation from '../../components/Calculators/Navigation/index.vue';
import QuizBanner from '../../components/QuizBanner.vue';

export default {
  components: {
    Tables, Navigation, QuizBanner,
  },
  mixins: [global],
  middleware({ $config, error, route }) {
    const validPaths = [
      '/tables/standard-normal-distribution-table/',
      '/tables/students-t-distribution-table/',
      '/tables/f-distribution-table/',
    ];

    if ($config.platform === 'fa' || !validPaths.includes(route.path)) {
      return error({ statusCode: 404, message: 'Page not found' });
    }
    return true;
  },
  data() {
    return {
      metaData: {
        'standard-normal-distribution-table': [
          'Standard Normal Distribution Table',
          'This z-score table contains the standard normal distribution critical values and the corresponding (1-α). Find the z-score you need here.',
        ],
        'students-t-distribution-table': [
          'Student’s T Distribution Table',
          'The Student’s t-distribution table contains the t-distribution critical values by confidence level and degrees of freedom. Find the t score you need here.',
        ],
        'f-distribution-table': [
          'F-Distribution Critical Values Table',
          'The F-distribution table provides critical values for different levels of significance (alpha) and degrees of freedom. Find the value you need here.',
        ],
      },
    };
  },
  head() {
    const fullPath = `${this.$config.calculatorsUrl}${this.$route.fullPath}`;
    const metaInfo = this.metaData[this.$route.path.split('/')[2]] || [];
    const [metaTitle, metaDescription] = metaInfo;

    return {
      titleTemplate: `${this.metaData[this.$route.path.split('/')[2]][0]} – Powered by 365 Data Science`,
      meta: this.metaProps({ metaTitle, metaDescription, fullPath }),
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      script: [
        { src: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-MML-AM_SVG', async: true },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tables {
  overflow: hidden;
  padding-top: var(--spacing-160);
  background-image: url('../../assets/images/home-v3-bg.webp');
  background-color: var(--main-light-shade-1);
}

@include bp($bp-mobile) {
  .tables {
    padding-top: 124px;

    .container {
      padding: 0;
    }
  }

  .col.col-4::v-deep {
    .tools {
      margin-bottom: 64px;
    }
  }
}
</style>
